import React from "react";
import BackgroundE4Z from "../BackgroundE4Z";


export default function Loading() {
  return (
    <BackgroundE4Z title={"Loading"} />
  );
}
